import React, { useCallback, useContext } from 'react'
import ReactPlayer from 'react-player'
import { DashboardStyles, Video, WrapVideo, WrapHeader, WrapContent, WrapTitle, Title, GeneralDashboardStyles, StudentDashboardStyles } from './Style'
import { constants } from './hooks'
import { Button } from 'components/Form'
import { ReactComponent as HandIcon } from 'assets/icons/Hand.svg';
import { ReactComponent as HandDisabled } from 'assets/icons/HandDisabled.svg';
import { FlexAround, FlexBetween, FlexCenter, Img, LightButton } from 'styles/GlobalStyle'
import { Go5, Task } from 'assets'
import { ReactComponent as LogoutIcon } from 'assets/icons/Logout.svg';
import { CircularProgress, SvgIcon } from '@mui/material'
import { CardStyles } from './Style'
import { thirdly2 } from 'styles/theme'
import { useSelector } from 'react-redux'
import { DashboardContext } from './DashboardContext'
import { secondary } from 'styles/theme'
import { white } from 'styles/theme'
import { thirdly5 } from 'styles/theme'
import { useNavigate } from 'react-router-dom'
import { app, performAssessments } from 'router/routes'
import { authHooks } from 'pages/Auth'
import { dashboardHooks } from '.'
import { performAssessmentsHooks } from 'pages/School/PerformAssessments'
import { useQuery } from '@tanstack/react-query'
import { getAssessmentPendingIdsFetch } from 'store/middlewares/assessment.crud'
import qc from 'keys/queryClient'
import './style.css'

const DashboardPage = () => {
    const { you, you2 } = dashboardHooks.constants
    const { dashboardData } = useContext(DashboardContext)
    const { user } = useSelector(state => state.user)

    const navigate = useNavigate()
    const { logout, logoutPending } = authHooks.useLogout()
    const performAssessments = performAssessmentsHooks.usePerformAssessments()

    const assessmentPending = useQuery({
        queryKey: [qc.pendingAssessments],
        queryFn: async () => {
            const { data } = await getAssessmentPendingIdsFetch()
            return data
        }
    })
    const { pending_ids, count } = assessmentPending.data || {}

    const handleFullScreen = () => {
        const player = document.querySelector('video');
        if (player) {
            player.requestFullscreen();
        }
    };

    const goPerformAssessments = useCallback(() => {

        const [firstId, ...rest] = performAssessments(pending_ids)

        navigate(`${app.performAssessments}/${firstId}`, {
            state: {
                remainingAssessmentIds: rest,
                totalAssessmentsCount: pending_ids?.length,
            }
        });
    }, [pending_ids])

    return (
        <StudentDashboardStyles cartoonHeight={240} cartoonWidth={160}>
            <div className='logout'>
                <Button
                    loading={logoutPending}
                    disabled={logoutPending}
                    action={logout}
                    width={"120px"}
                    direction="rtl"
                    color="light"
                    label="לצאת"
                    icon={<SvgIcon fontSize="small" component={LogoutIcon} inheritViewBox />}
                />
            </div>
            <div className='dashboard-content'>
                <div className='dashboard-cards-content'>
                    <CardStyles bg={thirdly2}>
                        <div>
                            {`שלום ${user?.first_name || ""},`}
                            <div>
                                {`כיף לראות ${you2[user?.gender]}`}
                            </div>
                        </div>
                        <div className='cartoon-img'>
                            <Img src={Go5} />
                        </div>
                    </CardStyles>
                    <div className='left-cards'>
                        <CardStyles height={"60%"}>
                            {count ?
                                count > 1 ?
                                    `יש ${you[user?.gender]} ${count}  משימות   ` :
                                    `מחכה ${you[user?.gender]} משימה` :
                                "אין משימות"
                            }
                            <div className='task-img'>
                                <Img src={Task} />
                            </div>
                        </CardStyles>
                        <CardStyles onClick={goPerformAssessments} button disabled={!count} alignCenter color={count ? white : thirdly5} bg={count ? secondary : "#CAD3DF"} height={"40%"}>
                            <div className='start-a-task'>
                                {"להתחיל"}
                                <div className='hand-img'>
                                    <SvgIcon fontSize="large" component={count ? HandIcon : HandDisabled} inheritViewBox />
                                </div>
                            </div>
                        </CardStyles>
                    </div>
                </div>
            </div>
        </StudentDashboardStyles >
    )
}

export default DashboardPage